import {Utils} from 'underscore-extensions';
export class SmoothScroll {

    constructor(private toElement: HTMLElement,
                private offset = 0,
                private duration = 500) {
    }

    scroll() {
        let startTime: number | undefined;
        const scrollTopDocument = (window.scrollY || window.pageYOffset);
        const elementOffset     = this.getOffsetTop();
        const deltaY            = elementOffset - scrollTopDocument;

        const scrollEasing = (x: number) =>
            x < 0.5 ? Math.pow(x * 2, 2) / 2 : 1 - Math.pow((1 - x) * 2, 2) / 2;

        const animateFrame = (timestamp: number) => {
            if (!startTime) startTime = timestamp;
            const progress = timestamp - startTime;
            const percent = progress >= this.duration ? 1 : scrollEasing(progress / this.duration);
            window.scrollTo(0, scrollTopDocument + (percent * deltaY));

            if (percent < 1) Utils.rAF(animateFrame);
        };

        Utils.rAF(animateFrame);
    };

    private getOffsetTop() {
        let el = this.toElement;
        let parent = <HTMLElement>el.offsetParent;
        while (parent !== document.body) {
            el = parent;
            parent = <HTMLElement>parent.offsetParent;
        }
        return el.offsetTop - this.offset;
    };
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/SmoothScroll.ts